module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture26-a87da3591e3414e38aa830758a397691.jpg";